import { useMutation } from '@apollo/client'
import { AddEventSample, AddEventSampleVariables } from '../../types'
import { ADD_EVENT_SAMPLE } from './operations'


export const useAddEventSample = () =>
  useMutation<AddEventSample, AddEventSampleVariables>(ADD_EVENT_SAMPLE)